/** @prettier */

import {Box, Stack, Card, CardContent} from '@mui/material';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';

//MTH component import
import GWActivate from './GWActivate';
import GWSetting from './GWSetting';
//interface import
import * as apiIF from '../../Type/api';
//Style import
import '../../css/common/common.css';

import {useOutlet} from './GWMain';

/**
 * ゲートウェイ一覧
 * @returns JSX
 */
const GWRegistration = () => {
  const trans = useTranslation().t; //翻訳関数
  //親コンポーネントから値を取得
  const {siteInfo, allGWInfo, setAllGWInfo} = useOutlet();

  const [tempActivateGW, setTempActivateGW] =
    useState<apiIF.res.getCompositionsActivation | null>(null); //仮ゲートウェイ情報
  const [exchangeGW, setExchangeGW] = useState<string[]>([]); //引継ぎ実施中ゲートウェイのIDリスト
  const [restActivationTime, setRestActivationTime] = useState<string[]>([]); //残りのアクティベーション時間リスト

  const activateButtonName = trans('GWRegistration.buttonTxt.addGateway'); //アクティベーションボタンの名前

  return (
    <>
      <Box className="gwSetting__title">
        {siteInfo == null ? <></> : siteInfo['site-name']}
      </Box>
      <Stack spacing={4}>
        {/* アクティベート中GW */}
        <GWActivate
          activateButtonName={activateButtonName}
          tempActivateGW={tempActivateGW}
          setTempActivateGW={setTempActivateGW}
          gwInfo={allGWInfo}
          setExchangeGW={setExchangeGW}
          setRestActivationTime={setRestActivationTime}
          restActivationTime={restActivationTime}
        />
        {/* アクティベート完了GW */}
        <GWSetting
          gwInfo={allGWInfo}
          setGWInfo={setAllGWInfo}
          timeZone={siteInfo === null ? '' : siteInfo['timezone']}
          setTempActivateGW={setTempActivateGW}
          setExchangeGW={setExchangeGW}
          exchangeGW={exchangeGW}
          setRestActivationTime={setRestActivationTime}
        />
        {/* 登録ゲートウェイが無い場合 */}
        <GWNone
          activateButtonName={activateButtonName}
          gwInfo={allGWInfo}
          tempActivateGW={tempActivateGW}
        />
      </Stack>
    </>
  );
};

/**
 * 登録ゲートウェイ無し表示
 * @param props props
 * @returns JSX
 */
const GWNone = (props: {
  activateButtonName: string;
  tempActivateGW: apiIF.res.getCompositionsActivation | null;
  gwInfo: apiIF.res.getCompositionsGateway | null;
}) => {
  const trans = useTranslation().t; //翻訳関数

  if (
    props.gwInfo === null ||
    props.gwInfo['gateway-informations'].length > 0 ||
    props.tempActivateGW === null ||
    props.tempActivateGW['gateway-informations'].length > 0
  ) {
    return <></>;
  }
  return (
    <Card className="gwSetting__contents--gw">
      <CardContent className="gwSetting__contents__noRegister">
        {trans('GWRegistration.instruction', {
          name: props.activateButtonName,
        })}
      </CardContent>
    </Card>
  );
};

export {GWNone};
export default GWRegistration;
